// removed by extract-text-webpack-plugin
module.exports = {"main-deals-group-wrapper":"DealsGroup_main-deals-group-wrapper---sb","mainDealsGroupWrapper":"DealsGroup_main-deals-group-wrapper---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DealsGroup/styles.less
// module id = 1686
// module chunks = 0